import { type OverlayPlacement } from "@dropbox/dig-components/overlay";
import { useIsAdminUser } from "@mirage/service-auth/useDropboxAccount";
import {
  DashTrialCTAButton,
  DashTrialCTAButtonVariant,
} from "./DashTrialCTA/DashTrialCTAButton";
import { DashTrialCTAIcon } from "./DashTrialCTA/DashTrialCTAIcon";

type DashTrialCTAProps = {
  adminName?: string;
  variant?: DashTrialCTAButtonVariant;
  tooltipVariant?: "withTitle" | "withoutTitle";
  tooltipPlacement?: OverlayPlacement;
  buttonSize?: "small" | "medium";
};

export const DashTrialCTA = ({
  adminName,
  variant = DashTrialCTAButtonVariant.PRIMARY,
  tooltipVariant = "withTitle",
  tooltipPlacement = "bottom-end",
  buttonSize = "medium",
}: DashTrialCTAProps) => {
  const isAdminUser = useIsAdminUser();
  return isAdminUser ? (
    <DashTrialCTAButton variant={variant} buttonSize={buttonSize} />
  ) : (
    <DashTrialCTAIcon
      adminName={adminName}
      tooltipPlacement={tooltipPlacement}
      tooltipVariant={tooltipVariant}
    />
  );
};
